import { Component } from 'react';
import { T, COMMON } from '../../common/js/i18n';
import imgFlowEn from "../../assets/flow-en.jpg";
import imgFlowZh from "../../assets/flow-zh.jpg";

interface Props {
    onClose?: () => void;
}

interface State {
}

export default class CodeGenHelp extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div style={{ padding: "0.5em" }}>
                <div style={{ textAlign: "left", maxWidth: "48em" }}>
                    {T({
                        en: "If you have never export the account file, please click the \"Export account file\" button in the upper right corner to download the account file, please safekeeping.When you log in next time, please log in by loading account file, otherwise your data will not be retrievable.",
                        zh: "如果你尚未导出账户文件，请点击右上角的“导出账户文件”按钮，导出账户文件妥善保存。下次登录的时候，通过选择账户文件的方式登录，不然数据将无法找回。"
                    })}
                </div>
                <div style={{ textAlign: "left" }}>
                    {T({
                        en: "Workflow of code generator",
                        zh: "代码生成器工作流程"
                    })}:
                </div>
                {T({
                    en: (<img src={imgFlowEn} alt="" />),
                    zh: (<img src={imgFlowZh} alt="" />)
                })}
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(COMMON.CLOSE)}</button>
                </div>
            </div>
        );
    }
}
